const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  nickname: state => state.user.nickname,
  userId: state => state.user.userId,
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js